export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS'
export const LOADING_PRODUCTS = 'LOADING_PRODUCTS'
export const SWAP_PRODUCTS = 'SWAP_PRODUCTS'

export const SET_FILTER = 'SET_FILTER'
export const RECEIVE_FILTERS = 'RECEIVE_FILTERS'
export const SET_BASE_FILTERS = 'SET_BASE_FILTERS'
export const RESET_FILTERS = 'RESET_FILTERS'
export const TOGGLE_FILTER_POPOVER = 'TOGGLE_FILTER_POPOVER'
export const SET_DYNAMIC_FILTERS = 'SET_DYNAMIC_FILTERS'
export const SET_CUSTOM_FILTERS = 'SET_CUSTOM_FILTERS'
export const SEASON_LESS = 'SEASON_LESS'

export const SET_SEARCH_FILTER = 'SET_SEARCH_FILTERS'
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY'
export const SEARCH_MODE = 'SET_SEARCH_MODE'
export const MAP_SEARCH_FILTER = 'MAP_SEARCH_FILTER'
export const SET_SEARCH_LIST_FILTER = 'SET_SEARCH_LIST_FILTER'
export const SET_SEARCH_FILTER_FROM_KEY = 'SET_SEARCH_FILTER_FROM_KEY'

export const SET_LANG = 'SET_LANG'
export const SET_LOCALE = 'SET_LOCALE'
export const SET_ROUTE = 'SET_ROUTE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js